function AddDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  var isoDate = result.toISOString().slice(0, 10);
  return isoDate;
}

export default AddDays;
